<template>
  <nav class="fixbnr">
    <ul>
			<li><a href="/contact"><img src="/images/common/contact_right_01.png" alt="お問い合わせ"></a></li>
			<li><a href="/sample"><img src="/images/common/contact_right_02.png" alt="サンプル請求"></a></li>
		</ul>
  </nav>
</template>

<style lang="scss" scoped>
.fixbnr{
  position: fixed;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  z-index: 1000;
  @media screen and (max-width: module.$phone){
    display: none;
  }
  ul{
    li{
      a{
        display: block;
        &:hover{
          opacity: .8;
        }
      }
      img{
        width: 3rem;
      }
    }
  }
}
</style>

<script>
export default {
}
</script>